import { PiShovelDuotone } from "react-icons/pi";
import { Card } from "src/components/card";
import { LeftSidebar } from "src/components/left-sidebar";
import { PageBase } from "src/components/page-base";
import { ToolSearch } from "src/apps/hr-config-management/components/tool-search";
import { useSearchParams } from "react-router-dom";
import { useRoles } from "src/context/roles-context";
import { SteelApp } from "../components/steel-app-access";
import { IT_TOOLS } from "../constants/ITTools";
import { GrantAccess } from "../components/grant-access";


const toolComponentMap: Record<string, React.ReactNode> = {
    "Steel Application Access": <SteelApp />,
    "Safety Compliance": <GrantAccess />,
};

export function IndexPage() {
   const userPermited = true;
   const roles = useRoles();
   const access = roles.checkHasRole("ITAdmin.SteelTool.Write") || roles.checkHasRole("ITAdmin.TaskerTool.Write");
   const [searchParams, setSearchParams] = useSearchParams();
   const activeTool = searchParams.get("tool") ?? "";

   function setActiveTool(tool: string)
   {
       setSearchParams(prev =>
           {
               prev.set("tool", tool);
               return prev;
           }
       );
   }
   return (
           <>
               {access ? (<PageBase pageName="IT Administation Tools" userPermitted={userPermited}>
                   <>
                       <LeftSidebar
                           extendedWidth="w-[400px]"
                           title="IT Administation Tools"
                           icon={
                               <PiShovelDuotone className="w-8 h-8 mr-2 text-[#ac2226]" />
                           }
                           collapsedContent={
                               <div className="[writing-mode:vertical-rl] font-bold text-lg flex items-center m-6">
                                   IT Administation Tools
                               </div>
                           }
                           >

                           <div className="flex flex-col gap-2">
                               <Card customization="">
                                   <ToolSearch
                                       tools={IT_TOOLS}
                                       categoryLabel="IT Tools"
                                       onToolSelect={setActiveTool}
                                       initialTool={activeTool}
                                   />
                               </Card>

                           </div>

                       </LeftSidebar>

                       <div className="flex-1 flex flex-col overflow-hidden p-8 gap-8 bg-gray-900">
                           {activeTool && toolComponentMap[activeTool] ? toolComponentMap[activeTool]: activeTool
                           ? <p className="text-sm text-gray-500">"{activeTool}" is not yet implemented.</p> : null
                           }
                       </div>
                   </>
               </PageBase> ) : (
                   <div className="p-4 label-text text-white">
                       Permission denied, you shouldn't be here...
                   </div>
               )}
           </>
       );
}